import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, {
  memo,
} from 'react';

// components
import SellerActionNeeded from './components/SellerActionNeeded';
import {
  firstMainRowMarginSides,
} from 'pages/Dashboard';
import ListingsSold from './components/ListingsSold';

// styles and components from material-ui
import Box from '@material-ui/core/Box';
import useIsMobile from 'now-frontend-shared/hooks/useIsMobile';
import AuctionsActive from './components/AuctionsActive';
import AuctionsEnded from './components/AuctionsEnded';

const sellerDashboardSectionsGap = 23;

const SellerDashboard = ({
  sellerAgreement,
  companyIsApprovedAndActive,
}) => {
  const isApplicable = sellerAgreement?.status.title === 'approved' && companyIsApprovedAndActive;
  const isMobile = useIsMobile();
  const sideMargin = isMobile ? 0 : firstMainRowMarginSides;
  return (
    <Box
      display="flex"
      flexDirection="column"
      style={{
        marginTop: 0,
        marginBottom: firstMainRowMarginSides,
        marginLeft: sideMargin,
        marginRight: sideMargin,
        gap: sellerDashboardSectionsGap,
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
      }}
    >
      <SellerActionNeeded
        isApplicable={isApplicable}
      />
      <AuctionsActive
        isApplicable={isApplicable}
      />
      <AuctionsEnded
        isApplicable={isApplicable}
      />
      <ListingsSold
        isApplicable={isApplicable}
      />
    </Box>
  );
};

SellerDashboard.propTypes = {
  sellerAgreement: PropTypes.shape({
    status: PropTypes.shape({
      title: PropTypes.string.isRequired,
    }).isRequired,
  }),
  companyIsApprovedAndActive: PropTypes.bool.isRequired,
};

SellerDashboard.defaultProps = {
  sellerAgreement: undefined,
};

export default compose(
  connect(({ auth }) => ({
    sellerAgreement: auth?.user?.company?.sellerAgreement,
    companyIsApprovedAndActive: !!auth?.user?.company?.approved && !!auth?.user?.company?.active,
  })),
  memo,
)(SellerDashboard);
